import React from 'react'
import { FaRegUser } from 'react-icons/fa'
import { TbWorld } from 'react-icons/tb'
import { MdOutlineConfirmationNumber, MdOutlineAdminPanelSettings, MdOutlineSettings, MdOutlineHistory } from 'react-icons/md'
import { HiOutlineClipboardList, HiOutlineUsers, HiOutlineUpload } from 'react-icons/hi'

/* Maps feature_access keys → which tab IDs they unlock.
   Add more entries here as new features are onboarded. */
const FEATURE_TAB_MAP = {
  agent_dashboard_page:  ['agent', 'tickets'],
  ticket_assigned_page:  ['ticket_assignments'],
  admin_page:            ['admin_page', 'agent_page', 'uploader'],
  settings_page:         ['settings'],
  ert_page:              ['trip-history'],
}

/* Maps sub-pages → their parent sidebar tab, so the parent stays highlighted */
const PARENT_TAB_MAP = {
  'ticket-detail':            'tickets',
  'assignment-ticket-detail': 'ticket_assignments',
  'vehicle-360':              'agent',
}

const ALL_MENU_ITEMS = [
  { id: 'agent',             label: 'Agent',               icon: <FaRegUser /> },
  { id: 'tickets',           label: 'Ticket 360',          icon: <MdOutlineConfirmationNumber /> },
  { id: 'ticket_assignments', label: 'Ticket Assignments', icon: <HiOutlineClipboardList /> },
  { id: 'trip-history',      label: 'Trip History',        icon: <MdOutlineHistory /> },
  { id: 'agent_page',        label: 'My Agents',           icon: <HiOutlineUsers /> },
  { id: 'uploader',          label: 'Uploader',            icon: <HiOutlineUpload /> },
  { id: 'admin_page',        label: 'Admin',               icon: <MdOutlineAdminPanelSettings /> },
  { id: 'settings',          label: 'Settings',            icon: <MdOutlineSettings /> },
]

const AdminSidebar = ({
  currentPage,
  currentUser,
  setCurrentPage,
  onLogout,
  sidebarOpen,
  setSidebarOpen
}) => {
  const featureAccess = currentUser?.feature_access || []

  const allowedIds = new Set(featureAccess.flatMap(f => FEATURE_TAB_MAP[f] || []))

  const menuItems = ALL_MENU_ITEMS.filter(m => allowedIds.has(m.id))

  const activeId = PARENT_TAB_MAP[currentPage] || currentPage

  return (
    <>
      <div className={`adminsidebar-container${sidebarOpen ? '' : ' collapsed'}`}>

        {/* Close button */}
        <button
          className="sidebar-close-btn"
          onClick={() => setSidebarOpen(false)}
          title="Hide sidebar"
        >
          ×
        </button>

        <div className='adminsidebar-container-main'>

          {/* Header */}
          <div className='sidebar-header'>
            <img
              src="/indofast-image.png"
              alt="Indofast Energy"
              style={{ height: 40, width: 'auto', maxWidth: '100%', objectFit: 'contain' }}
            />
          </div>

          {/* Menu Items */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              padding: "0px 0px"
            }}
          >
            {menuItems.map((item) => (
              <div
                key={item.id}
                className={`sidebar-menu ${activeId === item.id ? 'active' : ''}`}
                onClick={() => setCurrentPage(item.id)}
                style={{
                  cursor: 'pointer',
                  opacity: activeId === item.id ? 1 : 0.8,
                  transition: 'opacity 0.2s',
                  padding: '10px 14px',
                  borderLeft:
                    activeId === item.id
                      ? '3px solid #0090D9'
                      : '3px solid #1d5799',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >

                {/* Icon */}
                <span
                  className="sidebar-menu-icon"
                  style={{
                    fontSize: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    color:'white'
                  }}
                >
                  {item.icon}
                </span>

                {/* Label */}
                <span className='sidebar-menu-content' style={{ fontWeight: activeId === item.id ? 700 : 400 }}>
                  {item.label}
                </span>

              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div
          className="adminsidebar-footer"
          style={{
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '10px'
          }}
        >

          {/* User Info */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              width: '100%'
            }}
          >
            <div className="user-avatar">
              {(currentUser?.full_name || "AG")
                .split(" ")
                .filter(Boolean)
                .slice(0, 2)
                .map((part) => part[0])
                .join("")
                .toUpperCase()}
            </div>

            <div className="user-info">
              <p>{currentUser?.full_name || "Agent"}</p>

              <span className="status">
                ● {currentUser?.availability_status || "available"}
              </span>
            </div>
          </div>

          {/* Logout Button */}
          {onLogout && (
            <button
              onClick={onLogout}
              style={{
                width: '100%',
                padding: '7px 0',
                border: '1px solid rgba(255,255,255,0.15)',
                borderRadius: '6px',
                background: 'rgba(239,68,68,0.12)',
                cursor: 'pointer',
                fontSize: '12px',
                fontWeight: 600,
                color: '#FCA5A5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
              }}
              onMouseEnter={(e) =>
                e.currentTarget.style.background = 'rgba(239,68,68,0.25)'
              }
              onMouseLeave={(e) =>
                e.currentTarget.style.background = 'rgba(239,68,68,0.12)'
              }
            >
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>

              Logout
            </button>
          )}
        </div>
      </div>
    </>
  )
}

export default AdminSidebar